<template>
    <div class="coupon_details">
        <div style="height: 2.4rem;padding: .3rem 0;flex: 0 0 auto;">
            <coupon-item :coupon="data"></coupon-item>
        </div>
        <div class="coupon_details_explain">
            <h2 style="margin-bottom: .2rem">说明:</h2>
            <p class="coupon_details_explain_content" v-for="item in data.couponCaption.split(/[\n]/)">{{item}}</p>
            <h2 style="margin-bottom: .2rem;margin-top: .5rem">可用发站网点:</h2>
            <p class="coupon_details_explain_content">{{data.organNameList.length > 0 ? data.organNameList.join('、') :
                '无限制'}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "couponDetails",
        data() {
            return {
                data: {organNameList: []}
            }
        },
        components: {
            CouponItem: () => import('./components/couponItem')
        },
        watch: {
            $route(to, from) {
                if (to.path == '/couponDetails') {
                    this.data = this.$route.query.item
                    if (this.data) this.data = JSON.parse(this.data)
                }
            }
        },
        mounted() {
            this.data = this.$route.query.item
            if (this.data) this.data = JSON.parse(this.data)
        }
    }
</script>

<style scoped lang="scss">
    .coupon_details {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        &_explain {
            background-color: #fff;
            flex-grow: 1;
            padding: .35rem;

            &_content {
                line-height: .6rem;
                font-size: .36rem;
            }
        }
    }
</style>